export const ShopNoRnrPage = () => {
  return (
    <div className="min-h-screen items-center flex justify-center">
      <div className="max-w-72 text-center">
        {
          'Once your results are ready, your personalized formulas will be prepared, shipped, and delivered within 1–2 weeks. You can manage your plan and monthly formula selection directly from your Account.'
        }
      </div>
    </div>
  );
};
